/**
 * requestIdleCallback() method support for Safari
 */
import { addRequestIdleCallback } from '@core/utils/request-idle-callback';
addRequestIdleCallback(window);
